import React from 'react';
import { Search, Undo2, Plus } from 'lucide-react';
import { Book } from '../../../types/book.types';
import { SaleReturnViewType } from '../../../types/view.types';
import { Spinner } from '../../common/Spinner';

interface ActionButtonsProps {
  view: SaleReturnViewType;
  currentReturnTxId: string | null;
  returnCart: any[];
  handleProcessReturn: (txId: string, cart: any[], flag: boolean) => void;
  numpadValue: string;
  handleScan: (val: string) => void;
  simulateRandomScan: () => void;
  detailedBookId: string | null;
  selectedSearchSource: any | null;
  filteredBooksForSearch: Book[];
  addToCart: (book: Book, source?: any) => void;
  setSearchQuery: (v: string) => void;
  setNumpadValue: (v: string) => void;
  setIsSearchFocused: (v: boolean) => void;
  setDetailedBookId: (v: string | null) => void;
  setSelectedSearchSource: (v: any | null) => void;
  handleManualEntry: (val: string) => void;
  isScanning: boolean;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  view,
  currentReturnTxId,
  returnCart,
  handleProcessReturn,
  numpadValue,
  handleScan,
  simulateRandomScan,
  detailedBookId,
  selectedSearchSource,
  filteredBooksForSearch,
  addToCart,
  setSearchQuery,
  setNumpadValue,
  setIsSearchFocused,
  setDetailedBookId,
  setSelectedSearchSource,
  handleManualEntry,
  isScanning,
}) => {
  return (
    <div className="action-buttons-container">
      <button
        onClick={() => {
          if (view === 'returns') {
            if (currentReturnTxId) {
              handleProcessReturn(
                currentReturnTxId,
                returnCart.filter((i) => i.quantity > 0),
                false
              );
            } else {
              if (numpadValue) {
                handleScan(numpadValue);
              } else {
                simulateRandomScan();
              }
            }
          } else {
            if (detailedBookId && selectedSearchSource) {
              // El libro detallado siempre sale de los resultados actuales del
              // buscador, que ya vienen de /books_list.
              // Solo los libros sin stock se detallan y tienen fuentes: entran al
              // ticket como linea de PEDIDO con el proveedor elegido, y el pedido
              // se genera al cobrar (ver handleProcessPayment).
              const book = filteredBooksForSearch.find((b) => b.id === detailedBookId);
              if (book) {
                addToCart(book, selectedSearchSource);
                setSearchQuery('');
                setNumpadValue('');
                setIsSearchFocused(false);
                setDetailedBookId(null);
                setSelectedSearchSource(null);
              }
            } else {
              handleManualEntry(numpadValue);
            }
          }
        }}
        disabled={
          isScanning ||
          (view === 'returns'
            ? currentReturnTxId
              ? !returnCart.some((i) => i.quantity > 0)
              : false
            : !numpadValue && !(detailedBookId && selectedSearchSource))
        }
        className={`action-btn-primary ${view === 'returns' ? 'action-btn-primary-returns' : 'action-btn-primary-sale'
          }`}
      >
        {isScanning ? (
          <>
            <Spinner size={20} />
            BUSCANDO...
          </>
        ) : view === 'returns' ? (
          currentReturnTxId ? (
            <>
              <Undo2 className="search-ticket-button-icon" />
              DEVOLUCIÓN PARCIAL
            </>
          ) : (
            <>
              <Search className="search-ticket-button-icon" />
              BÚSQUEDA DE TICKET
            </>
          )
        ) : (
          <>
            <Plus className="w-5 h-5" />
            AGREGAR PRODUCTO
          </>
        )}
      </button>
    </div>
  );
};
